import { React, useState, useEffect } from "react";
import AdminDashboardLayout from "../../layout/AdminDashboardLayout";
import { DashboardWrapper } from "../dashboard/dashboard.styled";
import EducationCharts from "./Partials/EducationCharts";
import FilterCategory from "../../components/ReusableComponents/FilterCategory";
import { TabList, videoHeader, audioHeader, bookHeader } from "./data";
import { useNavigate, useParams, Outlet } from "react-router";
import EducationTable from "./Sections/EducationTable";
import { getFilteredTableData } from "../../utils/Utils";
import { fetchEducationData } from "./utils";
import { Backdrop, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";

function EducationPage() {
	let { category, id } = useParams();
	let navigate = useNavigate();
	const [currentTab, setCurrentTab] = useState("video");
	const [tableData, setTableData] = useState([]);
	const [tableHeader, setTableHeader] = useState(videoHeader);
	const [loading, setLoading] = useState(false);
	const [dateFilter, setDateFilter] = useState("6 Months");
	const [filteredData, setFilteredData] = useState([]);

	useEffect(() => {
		// console.log(category);
		if (!id) {
			setLoading(true);
			getEducationTable(category);
		}
	}, []);

	useEffect(() => {
		handleDateFilterChange({ target: { value: dateFilter } });
	}, [tableData]);

	
	useEffect(() => {
		if (category) {
			setCurrentTab(category);
			setCurrentTableHeader(category);
			getEducationTable(category);
		} else {
			// If no category is selected, redirect to ongoing
			navigate(`/education/${currentTab}`, { replace: true });
		}
	}, [category]);

	const handleTabChange = (category) => {
		//call fetcheducation on click of anycategory to make api request
		setCurrentTab(category);
		navigate(`/education/${category}`);
		setCurrentTableHeader(category);
		getEducationTable(category);
	};

	const handleDateFilterChange = (e) => {
		// Filter TableData based on date - All Time, Today, Last 7 days, Last 30 days, Last 6 months, Last 12 months
		let filteredTableData = getFilteredTableData(e.target.value, tableData);
		setDateFilter(e.target.value);
		setFilteredData(filteredTableData);
		// console.log(filteredTableData)
	};

	const getEducationTable = async (category) => {
		// Fetch Lease table data
		setLoading(true);
		let data = await fetchEducationData(category || currentTab);
		data = data.map((item) => {
			return { id: item.id, ...item.attributes };
		});
		if (data.length > 0) {
			// console.log(data)
			setLoading(false);
			setTableData(data);
		} else {
			setLoading(false);
			setTableData([]);
			toast.error("Error fetching data!");
		}
	};



	//set new header on click of each category
	const setCurrentTableHeader = (currentTab) => {
		let TableCells = [];
		// let TableData = [];
		switch (currentTab) {
			case "video":
				TableCells = videoHeader;
				break;
			case "audio":
				TableCells = audioHeader;
				break;
			case "book":
				TableCells = bookHeader;
				break;
			default:
				TableCells = videoHeader;
		}
		setTableHeader(TableCells);
	};
	return (
		<AdminDashboardLayout>
			<DashboardWrapper>
				{/* display chart if no id is selected */}
				{!id && (
					<>
						<EducationCharts title={'Resources'} />
						<FilterCategory
							currentTab={currentTab}
							tabList={TabList}
							handleClick={(category) => handleTabChange(category)}
						/>
					</>
				)}
				{id ? (
					<Outlet context={[loading, setLoading]} />
				) : (
					<EducationTable
						category={category}
						headCells={tableHeader}
						TableData={filteredData}
						getEducationTable={getEducationTable}
						dateFilter={dateFilter}
						handleDateFilterChange={handleDateFilterChange}
					/>
				)}
				{loading && (
					<Backdrop
						sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
						open={loading}
						// onClick={() => setLoading(false)}
					>
						<CircularProgress color='inherit' />
					</Backdrop>
				)}
			</DashboardWrapper>
		</AdminDashboardLayout>
	);
}

export default EducationPage;
